// src/components/revenue/Donut.jsx
import React from "react";

const PALETTE = [
  "#4C6FFF", "#2DBE7B", "#F6B73A", "#EE5D50",
  "#8A6DF1", "#32B9C6", "#A0A0A0", "#FF8BD2"
];

function moneyToNumber(v) {
  if (typeof v === "number") return v;
  const s = String(v).replace(/[\$,]/g, "").trim().toUpperCase();
  if (s.endsWith("B")) return parseFloat(s) * 1e9;
  if (s.endsWith("M")) return parseFloat(s) * 1e6;
  return parseFloat(s);
}

export default function Donut({
  data = [],                 // [{ label, value }]
  centerValue = "",          // e.g., "$346.5B"
  size = 180,
  stroke = 24,
  showInfo = true,
  infoTitle = "Click to get more Info",
  onInfoClick,               // optional: open a help drawer/modal
}) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;

  const values = data.map(d => moneyToNumber(d.value || 0));
  const total = values.reduce((a, b) => a + (isNaN(b) ? 0 : b), 0) || 1;

  let acc = 0;

  return (
    <div className="donut">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <g transform={`translate(${size / 2} ${size / 2}) rotate(-90)`}>
          {/* background track */}
          <circle
            r={r}
            cx="0"
            cy="0"
            fill="transparent"
            stroke="rgba(0,0,0,0.06)"
            strokeWidth={stroke}
          />
          {/* colored segments */}
          {values.map((v, i) => {
            const pct = Math.max(0, v / total);
            const len = c * pct;
            const gap = c - len;
            const dasharray = `${len} ${gap}`;
            const dashoffset = -acc;
            acc += len;
            return (
              <circle
                key={i}
                r={r}
                cx="0"
                cy="0"
                fill="transparent"
                stroke={PALETTE[i % PALETTE.length]}
                strokeWidth={stroke}
                strokeDasharray={dasharray}
                strokeDashoffset={dashoffset}
                strokeLinecap="butt"
              />
            );
          })}
        </g>
      </svg>

      <div className="donut-center">
        <div className="v">
          {centerValue}
          {/* {showInfo && (
            <RowIcons
              showAI={false}
              sources={data?.[0]?.sources || []}
              baseFacts={data?.[0]?.baseFacts || []}
              nodeLabel={data?.[0]?.label}
            />
          )} */}
        </div>
        <div className="l">Total Revenue</div>
      </div>
    </div>
  );
}
